import { useNavigate } from 'react-router-dom';
import { auth } from '../../../lib/firebase';

const TicketSalesSection = () => {
  const navigate = useNavigate();

  const handleSellTicketClick = async () => {
    const user = auth.currentUser;
    if (!user) {
      navigate('/auth/sign-in?next=/seller-dashboard?action=create&type=ticket');
      return;
    }
    // Always open create modal in seller dashboard without verification gating
    navigate('/seller-dashboard?action=create&type=ticket');
  };

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <div className="order-2 md:order-1 relative">
            <img
              src="https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?auto=format&fit=crop&w=1400&q=80"
              alt="Live event crowd"
              loading="lazy"
              onError={(e) => { const t = e.currentTarget; t.onerror = null; t.src = '/download.jpg'; }}
              className="w-full h-72 md:h-96 object-cover rounded-2xl"
              style={{
                WebkitMaskImage: 'radial-gradient(ellipse at center, black 55%, transparent 100%)',
                maskImage: 'radial-gradient(ellipse at center, black 55%, transparent 100%)',
              }}
            />
          </div>
          <div className="order-1 md:order-2">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Selling Event Tickets?
            </h2>
            <p className="text-lg text-gray-600 mb-6">
              Get across to thousands of students. List your concert, party, or show tickets on Campus Market and boost attendance.
            </p>
            <button
              type="button"
              onClick={handleSellTicketClick}
              className="inline-flex items-center px-6 py-3 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Sell Tickets
              <i className="ri-ticket-line ml-2"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TicketSalesSection;